/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Mode for assessment question generation
 */
export type AssessmentMode = (typeof AssessmentMode)[keyof typeof AssessmentMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssessmentMode = {
  independent: 'independent',
  contextual: 'contextual',
} as const;
